import type { JSX } from 'react'

export const SubtitlesIcon = (): JSX.Element => (
  <use href='#subtitlesIcon' width='100%' height='100%' />
)
